// expose przAppMobile object
import '../../../../../../src-js/app-mobile.js';
  
// define handler
const handler1 = {

    get(target, prop, receiver) {
        const value = target[prop];
        if (value instanceof Function) {
          return function (...args) {
            return value.apply(this === receiver ? target : this, args);
          };
        }
        return value;
    },   
};

// export simple proxy
export default new Proxy(window.przAppMobile || {}, handler1);